import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SecondaryButton } from "src/ui/shared/CustomButton";
import { makeStyles } from "tss-react/mui";

import { CollapsibleGroupContext } from "../../shared/components/CollapsibleSection";

const useStyles = makeStyles()((theme) => ({
    collapseBtn: {
        marginRight: theme.spacing(1),
    },
}));

const ExpandAllButton = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);
    const { expandAll, setExpandAll } = useContext(CollapsibleGroupContext);

    return (
        <SecondaryButton
            name="expand-all"
            className={classes.collapseBtn}
            onClick={() => setExpandAll((prev) => !prev)}
            startIcon={expandAll ? <i className="fas fa-solid fa-minimize" /> : <i className="fas fa-solid fa-maximize" />}
        >
            {expandAll ? t("common:button.collapseAll") : t("common:button.expandAll")}
        </SecondaryButton>
    );
};

export default ExpandAllButton;
